import IncrementIcon from '@cp/src/assets/icons/IncrementIcon';
import { IMetricChangeCell } from './interfaces';
import { Typography } from '@navi/web-ui/lib/primitives';
import DecrementIcon from '@cp/src/assets/icons/DecrementIcon';
import cx from 'classnames';
import { getMetricValue } from './constants';
import { formatPercent } from '@cp/src/utils/commonUtils';

const MetricChangeCell = (props: IMetricChangeCell) => {
  const { metric } = props;
  const { value, change, metricFormat } = metric || {};
  const formattedPercentChange = formatPercent(Math.abs(change));
  const metricValue = getMetricValue(value, metricFormat);
  const textColor = change > 0 ? 'var(--green-base)' : 'var(--red-base)';

  return (
    <>
      <Typography variant="p3" color="var(--grayscale-2)" className="truncate">
        {metricValue}
      </Typography>
      {change ? (
        <div
          className={cx('flex items-center', {
            'text-green-base': change > 0,
            'text-red-base': change < 0
          })}
        >
          <Typography variant="p5" color={textColor} className="font-semibold flex truncate">
            (
            <Typography
              variant="p5"
              color={textColor}
              className="font-semibold truncate max-w-[80%]"
            >
              {formattedPercentChange}
            </Typography>
            <span className="ml-0.5">
              {change > 0 ? (
                <IncrementIcon />
              ) : (
                <div className="mt-0.5">
                  <DecrementIcon />
                </div>
              )}
            </span>
            )
          </Typography>
        </div>
      ) : null}
    </>
  );
};

export default MetricChangeCell;
